<div class="pdf-container">
  <div class="pdf-header">
    <h4 class="pdf-title">{{title}}</h4>
    <button class="download-btn" (click)="downloadPdf()">
      <i class="ri-download-2-line"></i>
      Download
    </button>
  </div>

  <!-- <div *ngIf="isLoading" class="loading-container">
    <div class="spinner"></div>
    <p class="loading-text">{{ 'Shared.LOADING' | translate }}</p>
  </div> -->
  <iframe *ngIf="safePdfUrl" [src]="safePdfUrl" frameborder="0" (load)="onIframeLoad()">
  </iframe>
</div>